module.exports = __webpack_public_path__ + "img/PTP.5bd6e274.png";